import lines from "./lines.json";

export const exist = (ligne, arret, direction) => {
  const find = lines.find(line => line.ligne === ligne);

  if (!find) {
    return false;
  }
  if (!find.stations.includes(arret)) {
    return false;
  }
  if (!Object.values(find.direction).includes(direction)) {
    return false;
  }

  return {
    ...find,
    stations: [arret],
    selected: find.direction.a === direction ? "a" : "r"
  };
};

export const ligneExist = ligne => lines.find(line => line.ligne === ligne);

export const arretExist = arret =>
  []
    .concat(...lines.map(({ stations }) => stations))
    .find(stations => stations.includes(arret));

export default exist;
